import * as yup from "yup";
import { VehicleFormData } from "../interfaces/Forms";

export const validationSchema: yup.ObjectSchema<VehicleFormData> = yup.object().shape({
  vehicleDetails: yup.object().shape({
    VehicleName: yup.string().required("Vehicle name is required"),
    brandName: yup.string().required("Brand name is required"),
    model: yup.string().required("Model is required"),
    manufacturerYear: yup
      .number()
      // .typeError("Manufacturer year must be a number")
      .required("Manufacturer year is required")
      .min(1900, "Year must be after 1900")
      .max(new Date().getFullYear(), "Year cannot be in the future"),
    trailerSize: yup.string().required("Trailer size is required"),
    chassisNumber: yup.string().required("Chassis number is required"),
    engineNumber: yup.string().required("Engine number is required"),
    insuranceExpiryDate: yup
      .string()
      .required("Insurance expiry date is required"),
    loadCapacity: yup.string().required("Load capacity is required"),
    rcNumber: yup.string().required("RC number is required"),
    bodyType: yup.string().required("Body type is required"),
    tiresCount: yup.string().required("Tires count is required"),
    trackingUrl: yup.string().url("Please enter a valid LivePin URL").optional(),
  }),

  addressDetails: yup.object().shape({
    addressLine1: yup.string().required("Address Line 1 is required"),
    addressLine2: yup.string(), // Optional
    city: yup.string().required("City is required"),
    state: yup.string().required("State is required"),
    country: yup.string().required("Country is required"),
    pincode: yup
      .string()
      .required("Pincode is required")
      .matches(/^\d{6}$/, "Pincode must be 6 digits"),
  }),

  insuranceDetails: yup.object().shape({
    insuranceNumber: yup.string().required("Insurance number is required"),
    insuranceDate: yup.string().required("Insurance date is required"),
    expiryDate: yup.string().required("Expiry date is required"),
  }),

  ownerDetails: yup.object().shape({
    ownerName: yup.string().required("Owner name is required"),
    firstName: yup.string().required("First name is required"),
    lastName: yup.string().required("Last name is required"),
    companyName: yup.string().required("Company name is required"),
    emailId: yup
      .string()
      .email("Invalid email format")
      .required("Email is required"),
    phoneNumber: yup
      .string()
      .required("Phone number is required")
      .matches(/^\d{10}$/, "Phone number must be 10 digits"),
    countryCode: yup.string().required("Country code is required"),
  }),
});
